/**
 * Main App File
 *
 * @author Creator-Solutions -> Owen Burns
 */

import { HashRouter, Router, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";

import router from "./navigation/Router";
import { FooterContainer } from "./features/static/footer/styling/Footer.styles";
import { useEffect } from "react";

const App = () => {
  useEffect(() => {
    document.title = "Owen Burns | QA Engineer";
  }, []);
  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
};

export default App;
